import { queryClient } from "merchant-api";
import { getApplicationOpts, getCurrentAppOpts } from "merchant-api/unified";
import { AppStatus } from "merchant-api/types";
import { getAppPlace, throwForClosedAppPlace } from "../appPlace/appPlace";

export async function getCurrentAppState({id, statuses}: {id?: string,  statuses?: AppStatus[]}) {
  const currentApp = await queryClient.fetchQuery(id ? getApplicationOpts(id) : getCurrentAppOpts(statuses));
  if (!currentApp) return undefined;
  const state = await getAppPlace(currentApp);
  throwForClosedAppPlace(state);
  return {id: currentApp.id, state: state as 'apply' | 'renewal' | 'offer' | 'checkout'};
}
